import React, { useMemo, useEffect, useState } from "react";
import LoadingIndicator from "react-loading-indicator";
import ReactTooltip from "react-tooltip";
import { useTranslation } from "react-i18next";
import usePrevious from "../../hooks/usePrevious";

import logger from "../../utils/LoggerFrontend";
import AvatarsCollection from "../AvatarsCollection";
import { ROLE_OWNER, ROLE_RECRUITER } from "../CampaignMembers/CampaignMembers.constants";

import * as Styled from "./ButtonBubble.styled";

const ButtonBubble = ({ bubbleId, members, onClick, isLoading = false }) => {
  const { t } = useTranslation();

  const [initialRequestDone, setInitialRequestDone] = useState(false);
  const previousIsLoading = usePrevious(isLoading);

  useEffect(() => {
    if (previousIsLoading && !isLoading) {
      setInitialRequestDone(true);
    }
  }, [isLoading, previousIsLoading]);

  const membersWithRole = useMemo(
    () => members?.filter((member) => member?.roles?.length),
    [members]
  );

  // Check if request has been done first and there are no members with roles to display
  if (initialRequestDone && !members?.length) {
    logger.log("error:ButtonBubble", "there are no members with roles to display", { members });
  }

  if (isLoading) {
    return (
      <Styled.LoadingWrapper data-testid="button-bubble-loader">
        <LoadingIndicator />
      </Styled.LoadingWrapper>
    );
  }

  return (
    <>
      <Styled.ButtonBubble
        onClick={onClick}
        data-tip=""
        data-for={`bubble-${bubbleId}`}
        data-testid={`button-bubble-${bubbleId}`}
      >
        <AvatarsCollection avatars={membersWithRole} />
      </Styled.ButtonBubble>

      <ReactTooltip
        id={`bubble-${bubbleId}`}
        effect="solid"
        place="bottom"
        backgroundColor="#1C1928"
      >
        {membersWithRole
          .sort((a) => (a.roles?.includes(ROLE_OWNER) ? -1 : 1))
          .map((member) => {
            const description = member.roles?.includes(ROLE_OWNER)
              ? t("Owner")
              : member.roles?.includes(ROLE_RECRUITER)
              ? t("Recruiter")
              : "";

            if (!description) {
              return;
            }

            return (
              <p key={member.id}>
                {description} - {member.userName}
                <br />
              </p>
            );
          })}
        {!members?.length && t("Manage campaign members")}
      </ReactTooltip>
    </>
  );
};

export default ButtonBubble;
